import React from "react";

import { Location, navigate } from "@reach/router";

import Back from './../Back/Back'
import Info from './../Info/Info'


import './MobileSingle.scss';

const MobileSingle = ({data, slug, isOpen, setIsOpen, controlAudio, setControlAudio, ...rest}) => {

    React.useEffect( () => {
        setIsOpen( false)
    }, [] )

    const [currentProject, setCurrentProject] = React.useState(null);
    const [ percentage, setPercentage ] = React.useState( 0 );
    const [ swap, setSwap ] = React.useState( false );
    const [creditsVisibility, setCreditsVisibility] = React.useState(false);
    const [color, setColor] = React.useState ( {
        main: 'rgba(29,29,29,1)',
        side: 'rgba(59,59,59,1)',
    } );

    React.useEffect( () => {
        setControlAudio( false )
    }, [] )


    React.useEffect( () => {
        data.projects &&
            setCurrentProject(data.projects.find(project => { return project.slug === slug }))
    }, [] )

    React.useEffect( () => {
        if (swap) {
            setColor({
                main: 'rgba(157,157,157,1)',
                side: 'rgba(60,60,60,1)',
            });
            setPercentage( 0 ) ;
        } else {
            setColor({
                main: 'rgba(60,60,60,1)',
                side: 'rgba(157,157,157,1)',
            });
            setPercentage( 0 ) ;
        }
    }, [swap] )

    const [unitVisible, setUnitVisible] = React.useState(true)
    const videoToPlay = React.useRef(null)

    /*
        Video autoplay 
    */
    // React.useEffect( () => {
    //     let promise = videoToPlay.current.play()
    //         setUnitVisible (false)
    //         if (promise !== undefined) {
    //             promise.then(_ => {
    //               console.log('primo colpo play')
    //                 if (videoToPlay.current.muted = true) {
    //                     videoToPlay.current.muted = false
    //                 }
    //             }).catch(error => {
    //                 console.log('errore 1: video non partito')
    //                 videoToPlay.current.muted = true
    //                 console.log(unitVisible)
    //                 setUnitVisible(true)
    //             });
    //         }
    // }, [])

    const [ present, setPresent] = React.useState( false )
    
    // React.useEffect( () => {
    //     currentProject &&
    //         currentProject.credits &&
    //             setPresent( true )
    // } )
    // /*
    //     Caption material
    // */

    const [ isVisible, setIsVisible ] = React.useState(false);

    React.useEffect( () => {
        let timer = null;
        timer = setTimeout( () => setIsVisible(true), 3000 );
        return function cleanup() {
            clearTimeout( timer );
        }
    }, [] )
        

    return (
        <section className= { `mobile-single` } >
                
            <div className={ `mobile-single-wrapper` } onClick={ () => [videoToPlay.current.play(), setUnitVisible(false) ] } >    

                <div className={ [ `mobile-single-wrapper-video`, `${ creditsVisibility ? `mobile-single-wrapper-video--is-opaque` : `mobile-single-wrapper-video--not-opaque` }`].join( ` ` ) } >
                    <video 
                        ref={videoToPlay}
                        controls={false}
                        className={ [ `${ creditsVisibility ? `mobile-single-wrapper--is-opaque` : `mobile-single-wrapper--not-opaque` }`].join( ` ` ) } 
                        onTimeUpdate={ event => setPercentage( event.target.currentTime / event.target.duration * 100 ) } 
                        onEnded={event => [ setSwap(!swap), event.target.play() ]} 
                        playsInline
                        // onClick={ event => [event.target.muted = false, setUnmuteVideo(false)]}
                        poster={currentProject && currentProject.poster}
                    >
                        { currentProject &&  <source src={currentProject.video} type="video/mp4" /> }
                        Your browser does not support the video tag.
                        
                    </video>
                    <span className={[`strong mobile-single-wrapper-video-unit`, `${ !unitVisible && `dissappear`}`].join( ` ` ) }  >{currentProject && currentProject.unit}</span>
                </div>



                <ul className={[`mobile-single-wrapper-caption`,`caption--${isVisible ? `visible` : `hidden` }`].join(' ')}  >
                    <li className={`_credits strong mobile-single-wrapper-caption-title mobile-single-wrapper-caption-title--${ creditsVisibility ? 'is-visible' : 'not-visible' }`}>
                        <span className={ `${currentProject && currentProject.credits && `` }` } >{currentProject && currentProject.title}</span>
                        <span >{currentProject && currentProject.author}</span>
                    </li>
                    {
                        currentProject && 
                            currentProject.credits && (
                                <ul className={ [`_credits`,`mobile-single-wrapper-caption-credits`, `mobile-single-wrapper-caption-credits--${ creditsVisibility ? `is-visible` : `not-visible` }` ].join( ` ` ) }>
                                    
                                    {
                                        currentProject.credits.map( 
                                            (row, index) => {
                                                return <li key={index} className={`_credits`}> {row} </li>
                                            }
                                        )
                                    }
                                    {
                                        currentProject.filmography && 
                                        
                                        currentProject.filmography.map( 
                                            (row, index) => {
                                                return <li key={index} className={`_credits filmography${index}`}> {row} </li>
                                            }
                                        )
                                    }
                                </ul>
                            )                          
                    }

                    <li className={`mobile-single-wrapper-caption-timebar`} style={ { background: color.main }} >
                        <span className={`video-progress`} style={ { background:color.side, width: `${percentage}%` }}  ></span>
                    </li> 
                </ul>
            </div>
            <div className={[`mobile-single-navigation`, `navigation--${isVisible ? `visible` : `hidden` }`].join( ` ` )}>
                <Back onClick={() => navigate('/')} /> 
                {
                    currentProject && currentProject.credits &&
                        <Info onClick={() => [currentProject && currentProject.credits && setCreditsVisibility( !creditsVisibility ), setPresent( !present )]  } present={ present } />
                }
                {/* <Info onClick={() => currentProject && currentProject.credits && setCreditsVisibility( !creditsVisibility ) } present={ present } />  */}
            </div>
            


        </section>
    )
}

export default MobileSingle